import React, {Component} from 'react';
import {  Switch, Link, Route } from 'react-router-dom';
import MaintenanceContent from '../components/MaintenanceContent'; 
import axios from 'axios';
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import withRouter from '../components/withRouter';
import PageHeader from '../components/PageHeader'; 
import {api_base_url} from '../common/Constants'; 
 
class Maintenance extends React.Component{

    constructor(props){
        super(props);

        
        this.state = { 
            loading:1,
            type:[]
        }
    }

    componentDidMount()
    {
        
    }
 
    render()
    {
       
        return (
            <div className="page-wrapper">
                <Header/> 
                <PageHeader title="Maintenance Services" banner="Maintenance"/>
                <MaintenanceContent   />  
                <Footer/>
            </div>
       
        )
    }

}
export default withRouter(Maintenance);